import type { SVGProps } from "react";
const SvgPlayButtonLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 28"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.153 1.064c.342-.187.76-.172 1.089.039l18.666 12a1.066 1.066 0 0 1 0 1.794l-18.666 12A1.068 1.068 0 0 1 .598 26V2c0-.39.213-.749.555-.936M2.73 24.045 18.359 14 2.73 3.954z"
    />
  </svg>
);
export default SvgPlayButtonLight;
